export enum SchedulerContextMenuItemType {
  ADD_DELEGATION,
  ADD_HOURS_REQUEST,
  ADD_HOLIDAYS_REQUEST,
  ADD_HOLIDAY_PLAN,
  ADD_HOME_OFFICE_REQUEST,
}
